import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";
import { TipoContaType } from "./types";

class TipoContaProvider extends AProvider {
    constructor() {
        super("/cadastros/tipos_contas");
    }

    async fetchTiposConta(): Promise<TipoContaType[]> {
        const request: IDataRequest = { url: `${this.path}` }
        const response: IDataResponse = await api.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data?.rows.shit() || response.data
        }
        return [];
    }
}

export { TipoContaProvider }